/* ============================================================================
   CY A11Y (2026-09-30, design system Phase 2 batch E — HIG audit H3, M5, low)
   Names for controls Kalles labels with internal ids ("push-menu", "drawer-search"), the empty announcement links,
   the account and cart icons, the logo link and the icon-only remove buttons; and Escape that works on the first
   press in the search drawer and inside an open mega menu; autoplaying sliders that stop after one cycle (Phase 3).
   Enhancement only: without it the store works as before.
   ========================================================================== */
(function () {
  'use strict';
  if (window.CyA11y) return; window.CyA11y = true;

  function cartLabel() {
    document.querySelectorAll('.hdt-main-header a[href$="/cart"]').forEach(function (a) {
      var c = a.querySelector('hdt-cart-count'); var n = c ? parseInt(c.textContent, 10) || 0 : 0;
      a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }
  function names(root) {
    root = root || document;
    root.querySelectorAll('[aria-label="push-menu"]').forEach(function (b) { b.setAttribute('aria-label', 'Open menu'); });
    root.querySelectorAll('[aria-label="drawer-search"]').forEach(function (a) { a.setAttribute('aria-label', 'Search'); });
    root.querySelectorAll('.hdt-announcement-bar__slider-content > a').forEach(function (a) {
      if (a.textContent.trim() || a.hasAttribute('aria-label')) return;
      var t = a.parentElement.textContent.replace(/\s+/g, ' ').trim(); if (t) a.setAttribute('aria-label', t);
    });
    root.querySelectorAll('shopify-account:not([aria-label])').forEach(function (s) { s.setAttribute('aria-label', 'Account'); });
    root.querySelectorAll('.hdt-main-header .hdt-logo a').forEach(function (a) { a.setAttribute('aria-label', 'Cybeart home'); });
    root.querySelectorAll('input[data-input-search]:not([aria-label])').forEach(function (i) { i.setAttribute('aria-label', 'Search products'); });
    root.querySelectorAll('a.hdt-mini-cart__remove, a[href*="/cart/change"]').forEach(function (a) {
      if (!a.textContent.trim() && !a.getAttribute('aria-label')) a.setAttribute('aria-label', 'Remove item');
    });
    cartLabel();
  }

  /* Escape: the search field's own Escape only clears the text, and an open mega panel ignored it */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.getElementById('drawer-search-form');
    if (d && d.open && d.contains(document.activeElement)) {
      e.preventDefault(); e.stopPropagation();
      var x = d.querySelector('.hdt-dialog-btn__close'); if (x) x.click(); else d.close();
      return;
    }
    var open = document.activeElement && document.activeElement.closest && document.activeElement.closest('.hdt-main-header details[open]');
    if (open) {
      var s = open.querySelector('summary'); open.removeAttribute('open'); open.setAttribute('aria-expanded', 'false');
      if (s) s.focus();
    }
  }, true);

  /* Phase 3 (HIG motion): an autoplaying Kalles slider (announcement bar, home hero) plays one full cycle and then
     rests on its first slide; a touch or a press stops it at once. The engine's own Autoplay plugin already stops on
     focus. The slider api is private, so it is taken from the element's "select:slide" event. */
  function carousels() {
    document.querySelectorAll('hdt-slider[config*="autoPlay"]').forEach(function (el) {
      var cfg = {}; try { cfg = JSON.parse(el.getAttribute('config') || '{}'); } catch (e) {}
      if (!(cfg.autoPlay > 0) || el.cyOneCycle) return; el.cyOneCycle = true;
      var api = null, moves = 0, done = false;
      function stop() {
        done = true; var ap = api && api.plugins && api.plugins().autoplay;
        if (ap) { ap.stop(); return; }
        /* no api yet (pressed before the first move): the engine's own hover pause holds it until then */
        [el].concat([].slice.call(el.querySelectorAll('.hdt-slider__viewport, .hdt-slider__container'))).forEach(function (n) {
          n.dispatchEvent(new MouseEvent('mouseenter'));
        });
      }
      el.addEventListener('init:slide', function (e) { api = (e.detail && e.detail.sliderApi) || api; });
      el.addEventListener('select:slide', function (e) {
        api = e.detail && e.detail.sliderApi; if (!api) return;
        if (done) { stop(); return; }
        moves += 1; if (moves >= api.scrollSnapList().length) stop();
      });
      el.addEventListener('pointerdown', stop, { passive: true });
    });
  }

  function start() {
    names();
    carousels();
    /* the cart count and the drawer are re-rendered after every add: keep the names current */
    if ('MutationObserver' in window) {
      var queued = false;
      new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; names(); }); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
